import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=3178b8ce&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=3178b8ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178b8ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3178b8ce')) {
      api.createRecord('3178b8ce', component.options)
    } else {
      api.reload('3178b8ce', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=3178b8ce&scoped=true&", function () {
      api.rerender('3178b8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PgC415szXlrN/JS/comp/Voucher.vue"
export default component.exports